import React from 'react'
import { StandardLayout } from 'shared/layout/StandardLayout'
import EmptyState from 'experiences/search/widgets/EmptyState'
import { defaultSSRProps } from 'lib/routing/nextPageUtils'
import { NextPage } from 'next'
import { PageProps } from 'types/page'

const NewSearch: NextPage<PageProps> = ({ metaTags }): JSX.Element => {
	return (
		<StandardLayout metaTags={metaTags}>
			<EmptyState />
		</StandardLayout>
	)
}
export const getServerSideProps = defaultSSRProps

export default NewSearch
